import { useContext } from 'react';
import { AppContext } from '../../context/appContext';
import { DATA_TYPES } from '../../constants';
/**
 * @param {string} dataType - type of data e.g: header, footer
 * @param {string} menuType - type of menu data e.g: main-menu, brand-menu
 * @returns menu data
 */
const useMenuData = (dataType, menuType) => {
  const [data] = useContext(AppContext);
  if (dataType === DATA_TYPES.HEADER) return data?.globalNavData?.header?.menus?.[menuType];
  return data?.globalNavData?.footer?.menus?.[menuType];
};

export default useMenuData;
